module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold.aa3fc1b5.woff2";